/* eslint-disable no-restricted-imports */
import {
  ArcElement,
  Legend,
  BarElement,
  CategoryScale,
  Tooltip,
  Chart,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  TimeScale,
} from 'chart.js';

import type {
  ChartOptions,
  ChartType,
  DefaultDataPoint,
  ScriptableContext,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export type ChartJSOrUndefined<
  TType extends ChartType = ChartType,
  TData = DefaultDataPoint<TType>,
  TLabel = unknown,
> = Chart<TType, TData, TLabel> | undefined;

Chart.register(
  CategoryScale,
  BarElement,
  Tooltip,
  ChartDataLabels,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  TimeScale,
  Legend,
  ArcElement,
);

Chart.defaults.font.family = 'Montserrat, sans-serif';

export { Bar, Line, Doughnut } from 'react-chartjs-2';

export type { ChartOptions, ScriptableContext };
